<template>
  <a class="items-center gap-ch text-sm text-inherit hover:underline" href="/app/crm/contact">
    <strong>Vragen?</strong>
    Bel ons op (072) 30 35 900
  </a>
</template>
